// The booked option has no file of its own. Until the option API returns
// source_file, resolve it from the pre-options that already carry the PDF.

const tradeIdVariants = (tradeId) => {
  const text = String(tradeId || "").trim();
  if (!text) {
    return [];
  }
  return [text, text.replace(/\//g, "-"), text.replace(/-/g, "/")];
};

const latest = (rows) => rows.reduce((best, row) => ((row.id || 0) > (best.id || 0) ? row : best));

const prefer = (rows, action) => {
  const preferred = rows.filter((row) => row.derivative_action === action);
  return latest(preferred.length ? preferred : rows);
};

const filePayload = (row) => {
  if (!row?.file?.id) {
    return null;
  }
  return { id: row.file.id, filename: row.file.filename };
};

export const chooseSourceFile = (option, preoptions) => {
  const variants = new Set(tradeIdVariants(option?.trade_id));
  if (!variants.size) {
    return null;
  }
  const matches = (preoptions || []).filter((row) => {
    const reference = String(row?.reference_code || "").trim();
    return row?.file?.id && variants.has(reference);
  });
  if (!matches.length) {
    return null;
  }

  const parentId = option?.parent_option ?? option?.parent_option_id;
  if (parentId) {
    const linked = matches.filter((row) => String(row.linked_option) === String(parentId));
    const action = Number(option.option_state) === 5 ? "partial_terminate" : "create";
    return filePayload(prefer(linked.length ? linked : matches, action));
  }

  const own = matches.filter((row) => !row.linked_option || String(row.linked_option) === String(option.id));
  return filePayload(prefer(own.length ? own : matches, "create"));
};

export const loadSourceFile = (option, httpGetPreOptions) => {
  if (option?.source_file?.id || !option?.portfolio) {
    return Promise.resolve(option?.source_file || null);
  }
  return Promise.all([
    httpGetPreOptions({ portfolio: option.portfolio, processed: "true" }),
    httpGetPreOptions({ portfolio: option.portfolio }),
  ]).then(([processed, pending]) => {
    const rows = [].concat(processed?.data || [], pending?.data || []);
    return chooseSourceFile(option, rows);
  });
};
